import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot, Slottable } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
const buttonVariants = cva(
// The focus ring is not optional and is not `outline-none`. It is the only
// indication a keyboard user has of where they are, and removing it is the
// single most common way an otherwise accessible interface becomes unusable
// without a mouse.
'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', {
    variants: {
        variant: {
            primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
            secondary: 'border border-border bg-surface text-surface-foreground hover:bg-surface-muted hover:border-border-strong',
            outline: 'border border-border bg-surface text-surface-foreground hover:bg-surface-muted hover:border-border-strong',
            ghost: 'hover:bg-accent hover:text-accent-foreground',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
            link: 'text-primary underline-offset-4 hover:underline',
        },
        size: {
            sm: 'h-8 px-3',
            md: 'h-10 px-4 py-2',
            lg: 'h-11 px-8',
            icon: 'h-10 w-10',
        },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
});
export const Button = forwardRef(function Button({ className, variant, size, asChild = false, loading = false, disabled, children, ...props }, ref) {
    const Component = asChild ? Slot : 'button';
    return (_jsxs(Component, { ref: ref, className: cn(buttonVariants({ variant, size }), className), 
        // A loading button must not be pressable again. Relying on the handler
        // to guard is what produces two reservations from one impatient
        // double-click.
        disabled: disabled === true || loading, "aria-busy": loading || undefined, ...props, children: [loading ? _jsx(Loader2, { className: "h-4 w-4 animate-spin", "aria-hidden": "true" }) : null, _jsx(Slottable, { children: children })] }));
});
export { buttonVariants };
//# sourceMappingURL=button.js.map